export default {
  'common.select.placeholder': 'Seleccione',
  'common.enabled': 'Habilitado',
  'common.disabled': 'Deshabilitado',
  'common.select.actStatus.disabled': 'Deshabilitado',
  'common.select.actStatus.enabled': 'Habilitado',
  'common.select.actStatus.ended': 'Finalizado',
  'common.select.gameType.slot': 'Tragamonedas',
  'common.select.gameType.live': 'En Vivo',
  'common.select.gameType.sport': 'Deportes',
  'common.select.gameType.lottery': 'Lotería',
  'common.select.gameType.fish': 'Pesca',
  'common.select.gameType.chess': 'Ajedrez',
  'common.select.gameType.minigame': 'Minijuego',
  'common.select.gameType.xlive': 'XLive',
  'common.select.gameType.esports': 'ESports',
  'common.select.gameType.arcade': 'Arcade',
  'common.select.gameType.bingo': 'Bingo',
  'common.select.gameType.unknown': 'Desconocido',
  'common.select.pointAwardStatus.claimed': 'Reclamado',
  'common.select.pointAwardStatus.expired': 'Expirado',
  'common.select.actTemplateType.rebate': 'Rebaja de Apuestas',
  'common.select.actTemplateType.custom': 'Promoción Personalizada',
  'common.select.actTemplateType.realtimeRebate': 'Rebaja para Juegos VIP',
  'common.select.actTemplateType.register': 'Bono de Registro',
  'common.select.actTemplateType.dailyFirstRecharge': 'Primer Depósito Diario',
  'common.select.actTemplateType.recharge': 'Bono de Depósito',
  'common.select.actTemplateType.loginRecharge': 'Sorteo de Recargas al Iniciar Sesión',
  'common.select.actTemplateType.luckySpin': 'Giro de Suerte',
  'common.select.actTemplateType.everyRecharge': 'Bono en Cada Depósito',
  'common.select.actTemplateType.invite': 'Invitar Amigos',
  'common.select.actTemplateType.infoBinding': 'Bono de Vinculación de Información',
  'common.select.actTemplateType.redPacketRain': 'Lluvia de Paquetes Rojos',
  'common.select.actTemplateType.firstDeposit': 'Bono de Primer Depósito',
  'common.select.actTemplateType.newRebate': 'Rebaja de Nuevas Apuestas',
  'common.select.manualSendUserStatus.notStarted': 'No Iniciado',
  'common.select.manualSendUserStatus.processing': 'Procesando',
  'common.select.manualSendUserStatus.success': 'Éxito',
  'common.select.manualSendUserStatus.failed': 'Fallido',
  'common.select.manualSendStatus.notStarted': 'No Iniciado',
  'common.select.manualSendStatus.processing': 'Procesando',
  'common.select.manualSendStatus.completed': 'Completado',
  'common.select.awardType.cash': 'Efectivo',
  'common.select.awardType.points': 'Puntos',
  'common.select.actName.vipReward': 'Recompensa VIP',
  'common.select.balanceSubType.deposit': 'Depósito',
  'common.select.balanceSubType.withdraw': 'Retiro',
  'common.select.balanceSubType.manualSend': 'Envío Manual',
  'common.select.balanceSubType.upgradeReward': 'Recompensa de Actualización',
  'common.select.balanceSubType.retentionReward': 'Recompensa de Retención',
  'common.select.balanceSubType.weeklySalary': 'Salario Semanal',
  'common.select.balanceSubType.monthlySalary': 'Salario Mensual',
  'common.select.balanceSubType.birthdayReward': 'Recompensa de Cumpleaños',
  'common.select.balanceSubType.upgradePoint': 'Puntos de Actualización',
  'common.select.balanceSubType.retentionPoint': 'Puntos de Retención',
  'common.select.balanceSubType.appDayPoint': 'Puntos Diarios de APP',
  'common.select.balanceSubType.h5DayPoint': 'Puntos Diarios de H5',
  'common.select.balanceSubType.realtimeRebate': 'Rebaja para Juegos VIP',
  'common.select.balanceSubType.rebate': 'Rebaja',
  'common.select.balanceSubType.registerBonus': 'Bono de Registro',
  'common.select.balanceSubType.rechargeBonus': 'Bono de Depósito',
  'common.select.balanceSubType.dailyFirstRechargeBonus': 'Bono Diario de Primer Depósito',
  'common.select.balanceSubType.loginRechargeLoginBonus': 'Inicio de Sesión',
  'common.select.balanceSubType.loginRechargeRechargeBonus': 'Depósito',
  'common.select.balanceSubType.redemptionCodeBonus': 'Bono de Código de Canje',
  'common.select.balanceSubType.luckySpinBonus': 'Bono de Giro de Suerte',
  'common.select.balanceSubType.everyRechargeBonus': 'Bono en Cada Depósito',
  'common.select.balanceSubType.inviteBonus': 'Bono de Invitación',
  'common.select.balanceSubType.inviteAchievementBonus': 'Bono de Logro',
  'common.select.balanceSubType.inviteeBonus': 'Bono del Invitado',
  'common.select.balanceSubType.infoBindingBonus': 'Bono de Vinculación de Información',
  'common.select.balanceSubType.chickTreasureBoxBonus': 'Bono de Caja de Tesoro',
  'common.select.balanceSubType.chickCheckinBonus': 'Bono de Verificación de Entrada',
  'common.select.balanceSubType.redPacketRain': 'Lluvia de Paquetes Rojos',
  'common.select.balanceSubType.treasureBoxDailyBonus': 'Distribución Diaria de Caja de Tesoro',
  'common.select.balanceSubType.newRebateBonus': 'Bono de Nueva Rebaja',
  'common.select.balanceSubType.firstDepositBonus': 'Bono de Primer Depósito',
  'common.select.balanceSubType.vendorLeaderboardBonus': 'Bono de Actividad de Tabla de Clasificación',
  'common.select.balanceSubType.manualDeposit': 'Depósito Manual',
  'common.select.balanceSubType.gameTransferIn': 'Transferencia de Juego Entrante',
  'common.select.balanceSubType.gameTransferOut': 'Transferencia de Juego Saliente',
  'common.select.balanceSubType.pointExchange': 'Intercambio de Puntos',
  'common.select.balanceSubType.actRechargeFuel': 'Combustible de Recarga',
  'common.select.balanceSubType.actInviteFuel': 'Combustible de Invitación',
  'common.select.balanceSubType.actJeepneyEnterReward': 'Recompensa de Entrada',
  'common.select.balanceSubType.actJeepneyStageReward': 'Recompensa de Etapa',
  'common.select.balanceSubType.upgradeTicket': 'Entrada de Actualización',
  'common.select.balanceSubType.weeklyTicket': 'Entrada Semanal',
  'common.select.balanceSubType.monthlyTicket': 'Entrada Mensual',
  'common.select.balanceSubType.birthdayTicket': 'Entrada de Cumpleaños',
  'common.select.balanceSubType.appDailyTicket': 'Entrada Diaria de APP',
  'common.select.balanceSubType.h5DailyTicket': 'Entrada Diaria de H5',
  'common.select.balanceSubType.weeklyPoint': 'Punto Semanal',
  'common.select.balanceSubType.monthlyPoint': 'Punto Mensual',
  'common.select.balanceSubType.birthdayPoint': 'Punto de Cumpleaños',
  'common.select.balanceSubType.retentionTicket': 'Entrada de Retención',
  'common.select.balanceSubType.appDailyPoint': 'Punto Diario de APP',
  'common.select.balanceSubType.h5DailyPoint': 'Punto Diario de H5',
};
